// The two SOAR feature flags, as the BE now returns them on GET /inventory/venue/{id}
// (SVEMS-998). `venue.page.js` spreads the raw venue response onto the venue it puts in
// VenueContext, so both fields are already there — read them through these two helpers
// rather than reaching for the raw field, so the gates stay greppable.
//
// Both take the venue from VenueContext, which is null until the venue request resolves,
// and every gate reads them on the first render — hence the coercion.
//
// For deciding WHICH FIELD OF A BOOKING PAYLOAD TO READ, use `isEatappSource(src.source)`
// from `booking.service.js` instead: that is a property of the record, not of the venue.
// An EatApp reservation carries its bill on `amount` and its notes on `note` whatever
// venue it is being viewed from, so those choices must follow the record.

// An Odoo venue keeps its supply cost and mark up inside Odoo, so the dashboard does not
// show those two fields on the product form.
export const isOdooVenue = (venue) => Boolean(venue?.odooIntegration);

// A SOAR venue gets the reservation wording, the Manifest columns and the pre-checkin
// fields; every other venue keeps the older booking screens.
export const isEatappVenue = (venue) => Boolean(venue?.eatAppIntegration);

// On an Odoo venue the BE can lock each kind of master data so it is only created and
// edited in Odoo (SVEMS-1262). Each lock is a separate flag on the same venue response,
// set per venue, so a venue can lock products but still manage its own locations. The BE
// rejects the write when the lock is on; these gates only hide the actions that would fail.
export const isOdooProductLocked = (venue) => Boolean(venue?.odooProductLock);

// Also hides Stocktake, which has no lock of its own: a stocktake writes supply item stock.
export const isOdooSupplyItemLocked = (venue) => Boolean(venue?.odooSupplyItemLock);

export const isOdooTaxLocked = (venue) => Boolean(venue?.odooTaxLock);

export const isOdooCategoryLocked = (venue) => Boolean(venue?.odooCategoryLock);

export const isOdooLocationLocked = (venue) => Boolean(venue?.odooLocationLock);
